import authHelper from 'src/api/auth/helper';

function AppCtrl($scope, $state, managementUserService, analyticsService, organizationService, loggerService, authService, modalService, keychain) {
  const currentUser = managementUserService.getCurrentUser();

  if (!currentUser) {
    authService.logout();
    $state.go('login');
    return;
  }

  if (currentUser.useNewTlPro) {
    $scope.showBetaBanner = true;
  }

  $scope.hideBetaBanner = function($event) {
    if ($event) $event.preventDefault();

    $scope.showBetaBanner = false;
  };

  analyticsService.identifyUser();

  loggerService.init();

  if (currentUser && !currentUser.acceptedTerms) {
    modalService.acceptTerms();
  }

  authHelper.setAuthToken(keychain.getManagementAuthToken());
}

AppCtrl.$inject = [
  '$scope',
  '$state',
  'jsSdk.managementUser',
  'analyticsService',
  'organizationService',
  'loggerService',
  'authService',
  'modalService',
  'jsSdk.keychain'
];

export default AppCtrl;



// WEBPACK FOOTER //
// ./src/components/app/appCtrl.js